import { trigger, style, animate, transition, state } from '@angular/animations';

export const slideInFromTop = (speed: number = 300) => trigger(
  'slideInFromTop', 
  [
    state(
      'void',
      style({ opacity: 0, transform: 'translateY(-100%)' })
    ),
    state(
      '*',
      style({ opacity: 1, transform: 'translateY(0)' })
    ),
    transition(
      'void => *', 
      [
        animate(`${speed}ms ease-out`)
      ]
    ),
    transition(
      '* => void', 
      [
        animate(`${speed}ms ease-out`)
      ]
    )
  ]
);
